import React, { FC, useEffect, useState } from "react";

import TabComponent, { TabIProps } from "~/components/TabComponent";

import s from "./DealerPassportForm.less";
import { BaseHoc as Base } from "~/components/Forms/DealerPassportForm2/Base/BaseHOC";
import Address from "~/components/Forms/DealerPassportForm2/Address";
import Owners from "~/components/Forms/DealerPassportForm2/Owners";
import Guide from "~/components/Forms/DealerPassportForm2/Guide";
import Employee from "~/components/Forms/DealerPassportForm2/Employee";
import Docs from "~/components/Forms/DealerPassportForm2/Docs";
import Epd from "~/components/Forms/DealerPassportForm2/Epd";
import Button from "~/shared/ui/Fields/Button";
import { useHistory, useParams } from "react-router-dom";
import Back from "~/components/Icons/arrow-prev2";
import { useTranslation } from "react-i18next";
import { ROLE_TYPES } from "~/constans/roles";
import { OpenModal } from "~/components/Forms/DealerPassportForm/config/types";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import DomainsAttentionModal from "~/components/Forms/DealerPassportForm/ui/DomainsAttentionModal";
import {
  useGetDealerDomainsQuery,
  useGetFreeIdMutation,
} from "~/schemas/generated/graphql";
import ManageEmailDomainsModal from "~/components/Forms/DealerPassportForm/ui/ManageEmailDomainsModal";
import { get } from "lodash";
import GetCoordinatesProvider from "./getCoordinates";
import { usePermissions } from "~/shared/context/PermissionContext";
import AddDealerBase from "./AddDealerBase";

export const tabsDealersPermission: TabIProps[] = [
  { id: "base", label: "О ДИЛЕРСКОМ ЦЕНТРЕ", permission: "dealer.getBase" },
  { id: "address", label: "Адреса ДЦ", permission: "dealer.getAddress" },
  { id: "cost", label: "Собственники ДЦ", permission: "dealer.getOwners" },
  { id: "sorting", label: "Руководство ДЦ", permission: "dealer.getGuide" },
  { id: "personal", label: "Сотрудники", permission: "dealer.getEmployee" },
  { id: "documents", label: "Документы", permission: "dealer.getDocs" },
  { id: "epd", label: "ЭПД", permission: "dealer.getEpd" },
];

interface ParamsIProps {
  id: string;
}

const DealerPassportForm2 = ({
  oneDealer = {},
  refetch,
  DealerId,
  isAdd,
  idArchive,
  dealersForSelect,
  DealerName,
}) => {
  const { t } = useTranslation();
  const { selected } = useGetLocationData();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const [showDomainsAttention, setShowDomainsAttentions] = useState(false);
  const [shouldSkipGetDomains, setShouldSkipGetDomains] = useState(isAdd);
  const [loadingFinished, setLoadingFinished] = useState(false);
  const [loadingStarted, setLoadingStarted] = useState(false);
  const history = useHistory();
  const setData = useSetLocationData();

  const { id } = useParams<ParamsIProps>();
  const goBack = () => {
    history.replace("/dealers/");
  };
  const visibleTabs = tabsDealersPermission.filter((tab) =>
    hasPermission(tab.permission)
  );
  const handleManageDomainNames = () => {
    setData("openModal", OpenModal.MANAGEDOMAINS);
  };
  const handleCloseModal = () => {
    setData("openModal", "");
  };
  const { data: domainsData, loading: loadingDomains } =
    useGetDealerDomainsQuery({
      variables: {
        dealerId: DealerId,
      },
      skip: shouldSkipGetDomains,
      fetchPolicy: "no-cache",
    });

  const domainsTotal = domainsData?.DealerGetter?.getDealerDomains?.total;

  const hasDomains = domainsTotal >= 1;
  /**
   * useEffect - устанавливает статус загрузки данных для доменов, идет проверка была ли загрузка
   */

  useEffect(() => {
    if (loadingDomains && !loadingStarted) {
      setLoadingStarted(true);
    } else if (!loadingDomains && loadingStarted) {
      setLoadingFinished(true);
    }
  }, [loadingDomains, loadingStarted]);

  /**
   * useEffect - устанавливает модальное окно с уведомлением только после того как были получены данные с сервера
   */
  useEffect(() => {
    if (loadingFinished) {
      if (!hasDomains) {
        setShowDomainsAttentions(true);
      } else {
        setShowDomainsAttentions(false);
      }
    }
  }, [loadingFinished, hasDomains]);

  /**
   * useEffect - управляет необходимостью пропустить запрос за данными по домену, если неустановлен dealerId
   */
  useEffect(() => {
    if (DealerId && DealerId !== "" && id !== "add") {
      setShouldSkipGetDomains(false);
    }
  }, [DealerId]);
  useEffect(() => {
    if (loadingFinished) {
      if (!hasDomains) {
        setShowDomainsAttentions(true);
      } else {
        setShowDomainsAttentions(false);
      }
    }
  }, [loadingFinished, hasDomains]);

  return (
    <div className={s.wrapper}>
      <div className={s.wrapperTop}>
        <h1 className={s.pageTitle}>
          КАРТОЧКА ДИЛЕРА {DealerName && DealerName}
        </h1>
        <div className={s.wrapBut}>
          <div className={s.back} onClick={goBack}>
            <Back /> {t("ui.back")}
          </div>
          {hasPermission("dealergraph.domains.get") && (
            <Button
              txtBtn={"Домены"}
              onClick={handleManageDomainNames}
              customClassName={s.domainsBut}
            />
          )}
        </div>
      </div>

      {visibleTabs.length > 0 && <TabComponent tabs={visibleTabs} />}

      {DealerId !== "add" ? (
        <>
          <Content
            DealerId={DealerId}
            idArchive={idArchive}
            selected={selected}
            dealersForSelect={dealersForSelect}
            hasPermission={hasPermission}
          />
          <ManageEmailDomainsModal
            handleCloseModal={handleCloseModal}
            oneDealerId={DealerId}
          />
          <DomainsAttentionModal
            isOpen={showDomainsAttention}
            closeModal={setShowDomainsAttentions}
          />
        </>
      ) : (
        <AddDealerBase DealerId={DealerId} />
      )}
    </div>
  );
};

export default DealerPassportForm2;

const Content = ({
  DealerId,
  idArchive,
  selected,
  dealersForSelect,
  hasPermission,
}) => {
  return (
    <>
      {selected === "base" && hasPermission("dealer.getBase") && (
        <Base
          DealerId={DealerId}
          idArchive={idArchive}
          dealersForSelect={dealersForSelect}
          allDisabled={!hasPermission("dealer.updateBase")}
        />
      )}
      {selected === "address" && hasPermission("dealer.getAddress") && (
        <GetCoordinatesProvider>
          <Address
            DealerId={DealerId}
            idArchive={idArchive}
            allDisabled={hasPermission("dealer.updateAddress")}
          />
        </GetCoordinatesProvider>
      )}
      {selected === "cost" && hasPermission("dealer.getOwners") && (
        <Owners
          DealerId={DealerId}
          idArchive={idArchive}
          allDisabled={!hasPermission("dealer.updateOwners")}
        />
      )}
      {selected === "sorting" && hasPermission("dealer.getGuide") && (
        <Guide
          DealerId={DealerId}
          idArchive={idArchive}
          allDisabled={!hasPermission("dealer.updateGuide")}
        />
      )}
      {selected === "personal" && hasPermission("dealer.getEmployee") && (
        <Employee DealerId={DealerId} idArchive={idArchive} />
      )}
      {selected === "documents" && hasPermission("dealer.getDocs") && (
        <Docs
          DealerId={DealerId}
          idArchive={idArchive}
          allDisabled={!hasPermission("dealer.updateDocs")}
        />
      )}
      {selected === "epd" && hasPermission("dealer.getEpd") && (
        <Epd
          DealerId={DealerId}
          idArchive={idArchive}
          allDisabled={!hasPermission("dealer.updateEpd")}
        />
      )}
    </>
  );
};
